import {
  Checkbox,
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "rothzerg-ui";

type FilterSheetProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function FilterSheet({ open, onOpenChange }: FilterSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" id="filter-sidebar">
        <SheetHeader>
          <SheetTitle>Filter</SheetTitle>
        </SheetHeader>
        <SheetBody>
          <Checkbox label="In stock only" id="filter-in-stock" />
          <Checkbox label="Kmart only" id="filter-kmart-only" style={{ marginTop: 8 }} />
          <Checkbox label="On sale" id="filter-on-sale" style={{ marginTop: 8 }} />
        </SheetBody>
      </SheetContent>
    </Sheet>
  );
}
